import TitleWithBackButton from '@bit/vibedev.web.components.title-with-back-button';

export default TitleWithBackButton;
